<template>
  <button
    class="up-btn"
    v-bind="$attrs"
  >
    <slot />
  </button>
</template>
<script>
export default {
  name: 'upButton',
  inheritAttrs: false,
};
</script>
<style lang="scss" scoped>
.up-btn {
  width: 100%;
  text-align: center;
  background: #fefefe;
  border: 2px solid #356899;
  color: #356899;
}
</style>
